<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.products') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <template v-if="device.isMobile">
          <div
            v-if="(hasRoleDelete || hasRoleEdit) && products.length > 0"
            class="col-6 col-lg-8 right">
            <div class="action">
              <div
                id="dropdownOptions"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <!-- <a
                    v-if="hasRoleEdit"
                    class="dropdown-item"
                    @click="openImportModal()">
                    <i class="fas fa-file-download"/>
                    <span class="name">{{ $t('button.importproduct') }}</span>
                  </a>
                  <a
                    v-if="hasRoleEdit"
                    class="dropdown-item"
                    @click="openImportUpdateModal()">
                    <i class="fas fa-file-download"/>
                    <span class="name">{{ $t('button.updatebyimportproduct') }}</span>
                  </a> -->
                  <a
                    v-if="hasRoleDelete"
                    :disabled="true"
                    class="dropdown-item"
                    @click="openSelectedItems()">
                    <i class="far fa-check-square"/>
                    <span>{{ $t('message.multipleselectitems') }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col right">
            <div class="action">
              <div
                v-if="hasRoleDelete"
                id="dropdownOptions"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    :disabled="true"
                    class="dropdown-item"
                    @click="openSelectedItems()">
                    <i class="far fa-check-square"/>
                    <span>{{ $t('message.multipleselectitems') }}</span>
                  </a>
                </div>
              </div>
              <div
                v-if="hasRoleEdit"
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openImportUpdateModal()">
                  <i class="fas fa-file-download"/>
                  <span class="name">{{ $t('button.updatebyimportproduct') }}</span>
                </button>
              </div>
              <div
                v-if="hasRoleCreate"
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openImportModal()">
                  <i class="fas fa-file-download"/>
                  <span class="name">{{ $t('button.importproduct') }}</span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">
        {{ $t('message.loading') }}
      </p>

      <div v-else>

        <div
          v-if="isShowActionButtons"
          class="row mt-1 mb-3">
          <div class="col-12 mb-1">
            <section-header :title="$t('message.multipleselectitems')"/>
          </div>
          <div class="col-12">
            <button
              :disabled="selectedProductIds.length == 0"
              type="button"
              class="btn btn-sm btn-danger mr-1"
              @click="openConfirmdeleteModal()">
              {{ $t('message.deletemultipleitems', {'number': selectedProductIds.length}) }}</button>
            <!-- <button type="button"
                    class="btn btn-sm btn-danger mr-1"
                    :disabled="selectedProductIds.length == 0">{{ $t('message.notavailableitems', {'number': selectedProductIds.length}) }}</button> -->
            <button
              type="button"
              class="btn btn-sm"
              @click="cancelSelectedItems()">{{ $t('button.cancel') }}</button>
          </div>
        </div>

        <template v-if="products.length === 0 && device.isMobile">
          <BaseNotFoundData
            :title="$t('apps.pos.message.notfoundproducts')"
          />
          <div class="row mt-3">
            <div class="col-12 text-center">
              <BaseButton
                className="btn-light"
                @click="$router.push({ name: 'ProductNew' })"
              >
                {{ $t('message.createfirstproduct') }}
              </BaseButton>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row mb-3">
            <div class="col-md-4 ml-auto">
              <label class="d-flex d-flex align-items-center">
                <span class="mr-2">
                  {{ $t('message.search') }}:
                </span>
                <base-input
                  v-model="query.q"
                  :placeholder="$t('placeholder.searchproduct')"
                  type="text"
                  clear
                  @onEnter="handleSearchEnter"
                  @onClear="handleSearchClear"
                />
              </label>
            </div>
          </div>

          <base-table
            :pagination="$store.state.app.pagination"
            tableClass="table-bordered"
            @onPageChange="handlePageChange"
          >
            <template #thead>
              <thead>
                <tr>
                  <th
                    :style="!isShowActionButtons ? 'display: none;' : ''"
                    width="50"
                    class="text-center">
                    <vs-tooltip
                      :text="$t('button.selectall')"
                      position="top">
                      <vs-checkbox
                        v-model="selectedProductAll"
                        color="#A3CA76"/>
                    </vs-tooltip>
                  </th>
                  <th
                    v-if="tableopts.image"
                    style="width: 50px;">{{ $t('message.image') }}</th>
                  <th v-if="tableopts.brand">{{ $t('message.brand') }}</th>
                  <th v-if="tableopts.category">{{ $t('message.category') }}</th>
                  <th v-if="tableopts.modifier">{{ $t('message.modifier') }}</th>
                  <th v-if="tableopts.discount">{{ $t('message.discount') }}</th>
                  <th v-if="tableopts.tax">{{ $t('message.tax') }}</th>
                  <th v-if="tableopts.barcode">{{ $t('message.barcode') }}</th>
                  <th v-if="tableopts.sku">{{ $t('message.sku') }}</th>
                  <th>{{ $t('message.item') }}</th>
                  <th>{{ $t('message.price') }}</th>
                  <th v-if="tableopts.cost">{{ $t('message.cost') }}</th>
                </tr>
              </thead>
            </template>
            <template #tbody>
              <tbody>
                <tr>
                  <td
                    v-if="products.length === 0"
                    colspan="2"
                    class="text-center">
                    {{ $t('message.notfounddata') }}
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in products"
                  :key="index"
                  style="width: 50px;vertical-align: middle;">
                  <td
                    :style="!isShowActionButtons ? 'display: none;' : ''"
                    class="text-center">
                    <vs-checkbox
                      :vsValue="item.product_id"
                      v-model="selectedProductIds"
                      color="#A3CA76"/>
                  </td>
                  <td v-if="tableopts.image">
                    <router-link
                      :to="{name: 'ProductEdit', query: {
                        'pid': item.product_id,
                        'pname': item.product_name
                      }}"
                      style="position: relative;top: -2px;">
                      <img
                        :src="item.images.thumbnail || defaultImages.product"
                        width="68"
                        height="68">
                    </router-link>
                  </td>
                  <td v-if="tableopts.brand">
                    <span
                      v-if="item.brand_name"
                      class="badge badge-secondary">
                      {{ item.brand_name }}
                    </span>
                  </td>
                  <td v-if="tableopts.category">
                    <span
                      v-if="item.category_name"
                      class="badge badge-secondary">
                      <i class="icon fas fa-sitemap"/>
                      {{ item.category_name }}
                    </span>
                  </td>
                  <td v-if="tableopts.modifier">
                    <span
                      v-for="(modifier, index) in item.modifiers"
                      :key="modifier.modifier_id"
                      class="badge badge-secondary"
                      style="margin-right: 5px;">
                      <i class="icon fas fa-project-diagram"/>
                      {{ modifier.modifier_name }}
                    </span>
                  </td>
                  <td v-if="tableopts.discount">
                    <span
                      v-for="(discount, index) in item.discounts"
                      :key="discount.modifier_id"
                      class="badge badge-secondary"
                      style="margin-right: 5px;">
                      <i class="fas fa-tag"/>
                      {{ discount.discount_name }}
                      <template v-if="discount.type == 'percentage'">
                        ({{ discount.amount }}%)
                      </template>
                      <template v-if="discount.type == 'number'">
                        ({{ currency }} {{ discount.amount }})
                      </template>
                    </span>
                  </td>
                  <td v-if="tableopts.tax">
                    <span
                      v-for="(tax, index) in item.taxes"
                      :key="tax.modifier_id"
                      class="badge badge-secondary"
                      style="margin-right: 5px;">
                      <i class="fas fa-dollar-sign"/>
                      {{ getMasterDataText(tax.tax_name, $t) }}
                      ({{ tax.amount }}%)
                    </span>
                  </td>
                  <td v-if="tableopts.barcode">
                    <div
                      v-for="(price, priceIndex) in item.prices"
                      :key="priceIndex">
                      <template>
                        <span v-if="price.barcode !== null">
                          {{ price.barcode }}
                        </span>
                        <span v-else>-</span>
                      </template>
                    </div>
                  </td>
                  <td v-if="tableopts.sku">
                    <div
                      v-for="(price, priceIndex) in item.prices"
                      :key="priceIndex">
                      <template>
                        <span v-if="price.sku_code !== null">
                          <router-link
                            :to="{name: 'ProductEdit', query: {
                              'pid': item.product_id,
                              'pname': item.product_name
                          }}">
                            {{ price.sku_code }}
                          </router-link>
                        </span>
                        <template v-else>
                          <span v-if="isFoundCustomSkuCode(item.prices)">-</span>
                        </template>
                      </template>
                    </div>
                  </td>
                  <td>
                    <div
                      v-for="(price, priceIndex) in item.prices"
                      :key="priceIndex">
                      <router-link
                        :to="{name: 'ProductEdit', query: {
                          'pid': item.product_id,
                          'pname': item.product_name
                      }}">
                        {{ getProductFullName(item.product_name, price.attributes) }}
                      </router-link>
                      <span
                        v-if="!price.is_available"
                        class="badge badge-danger"
                        style="font-size: 9px;position: relative;top: -1px;">ไม่มีจำหน่าย</span>
                    </div>
                  </td>
                  <td>
                    <div
                      v-for="(price, priceIndex) in item.prices"
                      :key="priceIndex">
                      <template v-if="price.price !== null">
                        <span>
                          {{ getNumber(price.price) }}
                        </span>
                      </template>
                      <template v-else>
                        {{ $t('message.variable') }}
                      </template>
                    </div>
                  </td>
                  <td v-if="tableopts.cost">
                    <div
                      v-for="(price, priceIndex) in item.prices"
                      :key="priceIndex">
                      <template v-if="price.cost !== null">
                        {{ getNumber(price.cost) }}
                      </template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </base-table>
        </template>
      </div>
    </div>

    <div
      id="importModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-print-a4"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('message.importproductfromexcel') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeImportModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <importproducts
              v-if="show_import"
              :isvalid.sync="isValidImportData"
              @get-import-products="getImportProducts"/>
          </div>
          <div class="modal-footer">
            <a
              href="https://treesoft.io/th/manual/product#item"
              target="_blank">{{ $t('button.learnmore') }} <i class="fas fa-external-link-alt"/></a>
            <template v-if="!$store.state.app.loading">
              <button
                type="button"
                class="btn btn-light"
                @click="closeImportModal()">
                {{ $t('button.close') }}
              </button>
              <button
                :disabled="import_products.length == 0 || !isValidImportData"
                type="button"
                class="btn btn-web"
                @click="saveImportProducts()"
              >
                {{ $t('button.save') }}
              </button>
            </template>
            <template v-else>
              <button
                :disabled="true"
                type="button"
                class="btn btn-light">
                {{ $t('button.close') }}
              </button>
              <button
                :disabled="true"
                type="button"
                class="btn btn-web">
                <i class="fas fa-spinner spin"/>
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div
      id="importUpdateModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-print-a4"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('message.importupdateproductfromexcel') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeImportUpdateModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <import-products-update
              v-if="show_import_update"
              :isvalid.sync="isValidImportUpdateData"
              @get-import-products="getImportUpdateProducts"/>
          </div>
          <div class="modal-footer">
            <a
              href="https://treesoft.io/th/manual/product#item"
              target="_blank">{{ $t('button.learnmore') }} <i class="fas fa-external-link-alt"/></a>
            <template v-if="!$store.state.app.loading">
              <button
                type="button"
                class="btn btn-light"
                @click="closeImportUpdateModal()">
                {{ $t('button.close') }}
              </button>
              <button
                :disabled="import_update_products.length == 0 || !isValidImportUpdateData"
                type="button"
                class="btn btn-web"
                @click="saveImportUpdateProducts()"
              >
                {{ $t('button.save') }}
              </button>
            </template>
            <template v-else>
              <button
                :disabled="true"
                type="button"
                class="btn btn-light">
                {{ $t('button.close') }}
              </button>
              <button
                :disabled="true"
                type="button"
                class="btn btn-web">
                <i class="fas fa-spinner spin"/>
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="delItems()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import importproducts from '@/components/custom/ImportProducts.vue'
import importProductsUpdate from '@/components/custom/ImportProductsUpdate.vue'
import useBarcodeScanner from '../../../../use/barcodeScanner'
import userPermissionMixin from '@/mixins/userPermission'
import { getMasterDataText } from '@/helpers'

export default {
  name: 'ProductAll',

  setup () {
    const {
      barcode,
    } = useBarcodeScanner({ delay: 100 })

    return {
      barcode,
    }
  },

  components: {
    importproducts,
    importProductsUpdate,
  },
  mixins: [userPermissionMixin],
  data () {
    return {
      getMasterDataText,
      ready: false,
      loading: false,
      show_import: false,
      show_import_update: false,
      import_products: [],
      import_update_products: [],
      isShowActionButtons: false,
      selectedProductIds: [],
      selectedProductAll: false,
      isValidImportData: false,
      isValidImportUpdateData: false,
      query: {
        page: this.$route.query.page,
        q: this.$route.query.q,
      },
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      tableopts: 'getTableopts',
      currency: 'getCurrency',
      defaultImages: 'getDefaultImages',
    }),
  },
  watch: {
    ready: function () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    selectedProductAll () {
      this.selectedProductIds = []
      if (this.selectedProductAll == true) {
        this.products.map(product => this.selectedProductIds.push(product.product_id))
      }
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = undefined
        this.query.q = undefined
        this.fetchData()
      }
    },
  },
  created () { // call api to get data and set state
    this.fetchData()
  },
  beforeMount () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 0,
    })
  },
  mounted () { // run script
    // set popup modal
    this.setModal('#importModal')
    this.setModal('#importUpdateModal')
    this.setModal('#confirmdeleteModal')

    $('#dropdownOptions').on('show.bs.dropdown', function () {
      document.body.classList.add('hide-table-fixed-header')
    })

    $('#dropdownOptions').on('hide.bs.dropdown', function () {
      document.body.classList.remove('hide-table-fixed-header')
    })

    window.addEventListener('barcode', this.onBarcode)
  },
  updated () { // re-rendered html
    this.updateUIDataTable()
  },
  destroyed () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
    window.removeEventListener('barcode', this.onBarcode)
  },
  methods: {
    async fetchData () {
      if (this.loading == false) {
        this.loading = true
        this.updateUrl()
        this.ready = false
        await this.$store.dispatch('getProducts', {
          page: this.query.page,
          limit: this.$store.state.app.limitRowsPerpage,
          q: this.query.q,
        })
        this.ready = true
        this.loading = false
      }
    },
    updateUIDataTable () {
      $('#dataTable tbody tr').each(function (idx) {
        var maxHeight = 0
        var div = $(this).find('td > div')
        div.each(function () {
          if ($(this).height() > maxHeight) maxHeight = $(this).height()
        })
        div.each(function () {
          $(this).css({
            height: maxHeight + 'px',
          })
        })
      })
    },
    isFoundCustomSkuCode (prices) {
      var foundSku = false
      prices.map(price => {
        if (price.sku_code !== null) {
          foundSku = true
        }
      })
      return foundSku
    },
    openImportModal () {
      $('#importModal').modal('show')
      this.show_import = true
    },
    closeImportModal () {
      $('#importModal').modal('hide')
      this.show_import = false
    },
    openImportUpdateModal () {
      $('#importUpdateModal').modal('show')
      this.show_import_update = true
    },
    closeImportUpdateModal () {
      $('#importUpdateModal').modal('hide')
      this.show_import_update = false
    },
    getImportProducts (isValid, results) {
      this.import_products = results
    },
    getImportUpdateProducts (isValid, results, refBy) {
      this.import_update_products = {
        ref_by: refBy,
        products: results,
      }
    },
    async saveImportProducts () {
      var that = this

      if (this.import_products.length == 0) {
        return false
      } else {
        var countItems = this.import_products.length
        var done = false

        for (const index in this.import_products) {
          const dataSet = this.import_products[index]

          let res = await this.$store.dispatch('insertProduct', dataSet)

          if (index >= this.import_products.length - 1 && !done) {
            done = true

            // close
            that.closeImportModal()

            setTimeout(async () => {
              // show notify
              that.notify(that.$vs, {
                text: that.$t('message.importproductsuccess', { number: countItems }),
                color: 'success',
                icon: 'cloud',
              })
              // fetch new data
              await that.fetchData()
            }, 300)
          }
        }
      }
    },
    async saveImportUpdateProducts () {
      const that = this

      if (this.import_update_products.length == 0) {
        return false
      } else {
        const countItems = this.import_update_products.products.length
        const dataSet = this.import_update_products
        const res = await this.$store.dispatch('updateProductByImport', dataSet)

        if (res.success) {
          this.closeImportUpdateModal()

          setTimeout(async () => {
          // show notify
            that.notify(that.$vs, {
              text: that.$t('message.importupdateproductsuccess', { number: countItems }),
              color: 'success',
              icon: 'cloud',
            })
            // fetch new data
            await that.fetchData()
          }, 300)
        }
      }
    },
    openSelectedItems () {
      if (this.isShowActionButtons == true) {
        this.cancelSelectedItems()
      } else {
        if (this.products.length > 0) {
          this.hideFilterTable()
          this.showActionButtons()
          try { document.querySelector('body .fixedHeader-floating').remove() } catch (e) {}
        }
      }
      $('html, body').animate({ scrollTop: 0 }, 'fast')
    },
    cancelSelectedItems () {
      this.showFilterTable()
      this.hideActionButtons()
      this.selectedProductAll = false
      this.selectedProductIds = []
    },
    showActionButtons () {
      this.isShowActionButtons = true
    },
    hideActionButtons () {
      this.isShowActionButtons = false
    },
    hideFilterTable () {
      // var $wrapperTable = document.querySelectorAll('#dataTable_wrapper .row')
      // $wrapperTable[0].style.display = 'none'
    },
    showFilterTable () {
      // var $wrapperTable = document.querySelectorAll('#dataTable_wrapper .row')
      // $wrapperTable[0].style.display = ''
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    async delItems () {
      var productIds = this.selectedProductIds
      for (let i in productIds) {
        let productId = productIds[i]
        let data = {
          product_id: productId,
        }
        await this.$store.dispatch('deleteProduct', data)
      }
      // show notify
      this.notify(this.$vs, {
        text: this.$t('message.deleted'),
        color: 'danger',
        icon: 'delete',
      })
      // finish loading
      this.showFinish(this.$Progress)
      // close modal
      this.closeConfirmdeleteModal()
      // fetch new data items
      this.fetchData()
      // cancel selected
      this.cancelSelectedItems()
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    handleSearchEnter () {
      this.query.page = undefined
      this.fetchData()
    },
    handleSearchClear () {
      this.query.q = undefined
      this.query.page = undefined
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
    onBarcode (event) {
      this.query.q = event.detail.code
      this.query.page = undefined
      this.fetchData()
    },
  },
}
</script>

<style scoped>
	#dataTable tbody tr td > div:last-of-type {
		margin-bottom: 0;
	}
  #dataTable a.badge {
    color: #FFF !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/items/product/All.vue